import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _39280ce9 = () => interopDefault(import('../pages/about-us/index.vue' /* webpackChunkName: "pages/about-us/index" */))
const _6d54f736 = () => interopDefault(import('../pages/contact-us/index.vue' /* webpackChunkName: "pages/contact-us/index" */))
const _db433c68 = () => interopDefault(import('../pages/help-center/index.vue' /* webpackChunkName: "pages/help-center/index" */))
const _5596269e = () => interopDefault(import('../pages/markets-price/index.vue' /* webpackChunkName: "pages/markets-price/index" */))
const _0c345be2 = () => interopDefault(import('../pages/privacy-policy/index.vue' /* webpackChunkName: "pages/privacy-policy/index" */))
const _0719373c = () => interopDefault(import('../pages/terms-of-use/index.vue' /* webpackChunkName: "pages/terms-of-use/index" */))
const _7392640c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-us",
    component: _39280ce9,
    name: "about-us___en"
  }, {
    path: "/contact-us",
    component: _6d54f736,
    name: "contact-us___en"
  }, {
    path: "/help-center",
    component: _db433c68,
    name: "help-center___en"
  }, {
    path: "/markets-price",
    component: _5596269e,
    name: "markets-price___en"
  }, {
    path: "/privacy-policy",
    component: _0c345be2,
    name: "privacy-policy___en"
  }, {
    path: "/terms-of-use",
    component: _0719373c,
    name: "terms-of-use___en"
  }, {
    path: "/",
    component: _7392640c,
    name: "index___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
